import { DateTimeUtil } from "src/app/core/framework/utils/date-time-util";
import { EnderecoUtil } from "../../gis/endereco/endereco-util";
import { Paciente } from "../paciente.model";
import { IdadeUtil } from './../../../core/framework/utils/idade-util';

export class PacienteLayoutUtil {

  static idadeUtil = new IdadeUtil();
  static dateTimeUtil = new DateTimeUtil();

  static tagSalvo = `<label class='tag tag-cyan' style='margin-left: 8px;' title='Este paciente já havia sido salvo anteriormente'>SALVO</label>`;
  static tagSemEndereco = `<label class='tag tag-warning' title='Se o endereço deste paciente estiver cadastrado, verificar se a coordenada geográfica foi encontrada ( na página de cadastro do paciente ).'>SEM ENDEREÇO</label>`;
  static tagCancelado = `<label class='tag tag-danger' style='margin-left: 8px;' title='O motivo do cancelamento pode ser visualizado na listagem de atendimentos...'>CANCELADO</label>`;


  static getPacienteInfo(paciente: Paciente, 
                         enderecoUtil: EnderecoUtil,
                         htmlDepoisDoNome?: string,
                         exibirDataNascimentoEIdade?: boolean): string {
    
    let str =  `<label style='display: block !important;'>
      <a class='clickable texto-escuro' 
         onclick="window.open(this.href, 'sumario_paciente', 'resizable=yes, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no, location=no, width=1000, height=600, left=10, top=10'); return false;"
         href='/homecare/sumario-paciente/${paciente.id}?standalone=true'>${paciente.nome}</a>`;

    if ( exibirDataNascimentoEIdade ) {
      const idade          = this.idadeUtil.getIdadeDescritiva(paciente.dataNascimento);
      const dataNascimento = this.dateTimeUtil.dateToDiaMesAno(paciente.dataNascimento);

      str += `<div style='margin:5px 0px 12px 0px;'>
          <label class='texto-cinza' style='display:block;margin-bottom:4px;'>${ dataNascimento }
            <i class='material-icons texto-cinza-super-claro' title='Data de nascimento' style='font-size:15px;vertical-align:text-bottom;'>star</i>
          </label>
          <label class='texto-cinza' style='display:block;'>${ idade }</label><div>`;
    }

    if ( htmlDepoisDoNome ) {
      str += htmlDepoisDoNome;
    }

    str += `</label>`;

    const endereco = enderecoUtil.getEnderecoEstilizado(paciente.endereco, paciente.telefone);
    
    return str + endereco;
  }

}